import { styled } from 'styled-components';
import Input from '../../../components/utils/Input/Input';
import ReactGoogleAutocomplete from 'react-google-autocomplete';

export const Title = styled.span`
  color: #000;
  font-feature-settings: 'case' on;
  font-family: Playfair Display;
  font-size: 33px;
  font-style: normal;
  font-weight: 700;
  user-select: none;
  line-height: normal;
  user-select: none;
`;
export const Icon = styled.span`
  position: absolute;
  right: 10px;
  top: 7px;
  user-select: none;
  cursor: pointer;
  font-size: 20px;
  @media (max-width: 1900px) {
    right: 13px;
  }
`;
export const SubTitle = styled.span`
  color: #000;
  font-feature-settings: 'case' on;
  font-family: Playfair Display;
  user-select: none;
  font-size: 24px;
  font-style: normal;
  user-select: none;
  font-weight: 600;
  line-height: normal;
`;

export const UnderlineText = styled.span`
  color: #1b1b1b;

  user-select: none;
  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  // line-height: normal;
  cursor: pointer;
  letter-spacing: -0.2px;
  text-decoration-line: underline;
  align-self: ${props => (props.$direction ? 'flex-end' : 'flex-start')};
`;

export const Text = styled.span`
  color: #000;

  font-size: 14px;
  user-select: none;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.2px;
  opacity: 0.5;
`;

export const TextDesc = styled.span`
  font-family: 'Poppins-Medium';
  font-size: 12px;
  letter-spacing: -0.408px;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 380px;
  max-width: 380px;
  gap: 44px;
  min-height: 567px;

  width: 100%;
  @media (max-width: 485px) {
    min-width: 100%;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  align-items: center;
`;

export const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  gap: 4px;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  user-select: none;
  cursor: pointer;
  /* align-items: center; */
  margin-top: -10px;
  gap: 8px;
  margin-left: 8px;
`;

export const UploadContainer = styled.div`
  transition: all 0.2s ease-in-out;
  min-height: 317px;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(220, 203, 197, 0.5);
  border: 1px solid #dccbc5;
  gap: ${props => (props.$selected ? '12px' : '64px')};
  padding: ${props => (props.$selected ? '12px 0px' : '12px 16px')};
  cursor: ${props => (props.$selected ? 'default' : 'pointer')};
  &:active {
    transition: all 0.2s ease-out;
    opacity: ${props => (props.$selected ? '1' : '0.65')};
  }
`;
export const ThinText = styled.span`
  color: #474747;
  font-family: 'Poppins-Regular';

  font-size: 12px;

  user-select: none;
`;
export const Text2 = styled.span`
  color: #000;
  user-select: none;
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.408px;
`;
export const UnderlineText2 = styled.span`
  color: #000;
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  user-select: none;
  letter-spacing: -0.408px;
  text-decoration-line: underline;
`;
export const Row2 = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
`;
export const Column2 = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ImagesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;
export const AddPhotoContainer = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 10px;
  background-color: #dccbc5;
  &:active {
    transition: all 0.2s ease-out;
    opacity: 0.65;
  }
`;
export const AddInputContainer = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;
export const IconsContainer = styled.div`
  width: ${props => (props.$width ? 'unset' : '100%')};
  display: flex;
  align-items: center;
  gap: 4px;
  flex-direction: row;
`;

export const ListContainer = styled.div`
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: absolute;
  left: 0;
  top: 50px;
  z-index: 1000;
  width: 50%;
  background-color: white;
  border-bottom: 1px solid #e2dddb;
  border-left: 1px solid #e2dddb;
  padding: 12px;
  border-right: 1px solid #e2dddb;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  height: 369px;
`;
export const DropdownContainer = styled.div`
  position: relative;
  height: 50px;
  cursor: pointer;
  align-items: center;
  display: flex;
`;

export const Dropdown = styled.div`
  width: 380px;
  background-color: white;
  border: none;
  outline: none;
  height: 100%;
  cursor: pointer;
  padding: 12px;
  border-bottom: ${props => (props.$open ? '1px solid #000' : '1px solid #e2dddb')};
`;
export const DropText = styled.span`
  color: #a9a9a9;
  opacity: 0.8;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.2px;
`;
export const DropValue = styled(DropText)`
  color: #000;
  user-select: none;
  &:hover {
    opacity: 0.6;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
export const IconContainer = styled.div`
  position: relative;
  width: 8rem;
  height: 8rem;
`;
export const LoaderContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1;
  width: 100%;
`;

export const StyledInput = styled(Input)`
  width: 100%;
`;
export const StyledInputWidth = styled(Input)`
  width: 100%;
`;

export const UploadInputBig = styled.input`
  background: red;
  width: 380px;
  position: absolute;
  height: 317px;
  border-radius: 10px;
  opacity: 0;
  cursor: pointer;
  @media (max-width: 1900px) {
    width: 100%;
  }
`;
export const UploadInputSmall = styled(UploadInputBig)`
  width: 80px;
  height: 80px;
`;
export const UploadInput = styled(UploadInputBig)`
  height: 54px;
  top: 0;
  left: 0;
`;

export const BannerInfo = styled.span`
  color: #000;
  font-family: 'Poppins-Light';
  font-size: 12px;
  letter-spacing: -0.2px;
  opacity: 0.5;
  margin-left: 3px;
`;

export const Skip = styled.span`
  color: #000;
  font-family: 'Poppins-Medium';
  font-size: 18px;
  letter-spacing: -0.2px;
  text-decoration: underline;
  text-align: center;
`;

export const AutoCompleteInput = styled(ReactGoogleAutocomplete)`
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: ${props => (props.$icon ? '12px 12px 12px 48px' : '12px 12px 12px 12px')};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-bottom: 1px solid #e2dddb;
  &:focus {
    outline: none;
    border-bottom: 1px solid #000;
  }
  &::placeholder {
    color: ${props => (props.$noOpacity ? '#000' : '')};
    opacity: ${props => (props.$noOpacity ? 1 : 0.5)};
  }

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.2px;
  background-color: transparent;
`;

export const TextDescAddress = styled.span`
  font-family: 'Poppins-Medium';
  font-size: 10px;
  letter-spacing: -0.408px;
  opacity: 0.5;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
`;
